import(/* webpackMode: "eager", webpackExports: ["NavBar"] */ "/app/app/components/NavBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/SessionProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/providers/ThemeProvider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["lightTheme"] */ "/app/app/components/Theme/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
